<template>
  <div class="tenant_option_info_area" id="tenant_option_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="passwordEnableFlagLabel"
        :valueLabel="passwordEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        v-if="showInitLoginPasswordLabel"
        :titleLabel="initLoginPasswordLabel"
        :valueLabel="corporation.initLoginPassword"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutEnableFlagLabel"
        :valueLabel="autoLogoutEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutSecondLabel"
        :valueLabel="autoLogoutSecond"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="ratingQuarityEnableFlagLabel"
        :valueLabel="ratingQuarityEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="pushNotificationEnableFlagLabel"
        :valueLabel="pushNotificationEnableFlag"
        :changeLabel="updatePushNotificationEnableFlag"
        :is-changed="
          corporation.pushNotificationEnableFlag !==
          inputData.pushNotificationEnableFlag
        "
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="spEnableFlagLabel"
        :valueLabel="spEnableFlag"
        :changeLabel="updateSpEnableFlag"
        :is-changed="corporation.spEnableFlag !== inputData.spEnableFlag"
      ></valueLabelSection>

      <valueLabelSection
        :titleLabel="contactsEnableFlagLabel"
        :valueLabel="contactsEnableFlag"
        :changeLabel="updateContactsEnableFlag"
        :is-changed="
          corporation.contactsEnableFlag !== inputData.contactsEnableFlag
        "
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="remarksLabel"
        :valueLabel="corporation.remarks"
        :changeLabel="inputData.remarks"
        :deleteLabel="corporation.remarks"
        :is-changed="corporation.remarks !== inputData.remarks"
        :is-deleted="inputData.remarks === ''"
      ></valueLabelSection>
    </div>
    <div class="edit_area_half">
      <callAppListSection
        :titleLabel="linkedApplication"
        :callAppList="corporation.callAppList"
        :changeCallAppList="inputData.callAppList"
        :is-changed="isCallAppListChanged"
      ></callAppListSection>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './updateValueLabelSection.vue'
import callAppListSection from './updateCallAppListSection.vue'

export default {
  props: {
    showInitLoginPasswordLabel: Boolean
  },
  data() {
    return {
      passwordEnableFlagLabel: 'アプリパスワードの使用有無',
      initLoginPasswordLabel: 'アプリ初期パスワード',
      autoLogoutEnableFlagLabel: 'アプリ自動ログアウトの使用有無',
      autoLogoutSecondLabel: '自動ログアウト時間',
      ratingQuarityEnableFlagLabel: '評価管理機能の使用有無',
      pushNotificationEnableFlagLabel: 'push通知機能の使用有無',
      spEnableFlagLabel: 'サイレントpush通知機能の使用有無',
      contactsEnableFlagLabel: '標準電話帳連携機能の使用有無',
      remarksLabel: '備考',
      passwordLabel: '管理者パスワード',
      initialValue: 3600,
      linkedApplication: '連携アプリ'
    }
  },
  components: {
    valueLabelSection,
    callAppListSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    inputData() {
      return this.$store.state.corporations.updateCorporation
    },
    passwordEnableFlag() {
      return this.$store.state.corporations.updateCorporation.passwordEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    autoLogoutEnableFlag() {
      return this.$store.state.corporations.updateCorporation.autoLogoutEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    ratingQuarityEnableFlag() {
      return this.$store.state.corporations.updateCorporation.ratingQuarityEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    pushNotificationEnableFlag() {
      return this.$store.state.corporations.corporation.pushNotificationEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    updatePushNotificationEnableFlag() {
      return this.$store.state.corporations.updateCorporation.pushNotificationEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    spEnableFlag() {
      return this.$store.state.corporations.corporation.spEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    updateSpEnableFlag() {
      return this.$store.state.corporations.updateCorporation.spEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    contactsEnableFlag() {
      return this.$store.state.corporations.corporation.contactsEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    updateContactsEnableFlag() {
      return this.$store.state.corporations.updateCorporation.contactsEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    autoLogoutSecond() {
      return (
        parseInt(
          this.$store.state.corporations.updateCorporation.autoLogoutSecond /
            3600
        ) + '時間'
      )
    },
    isCallAppListChanged() {
      const originalIds = this.corporation.callAppList
        .filter((app) => app.isActiveCallAppNotNull)
        .map((app) => app.id)
        .sort()
        .join(',')
      const inputIds = this.inputData.callAppList
        .map((app) => app.id)
        .sort()
        .join(',')
      return originalIds !== inputIds
    }
  }
}
</script>

<style scoped>
.detail_content {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantOptionUpdateInfo.vue